import { render, staticRenderFns } from "./PetInfo.vue?vue&type=template&id=140804a0&scoped=true&"
import script from "./PetInfo.vue?vue&type=script&lang=js&"
export * from "./PetInfo.vue?vue&type=script&lang=js&"
import style0 from "./PetInfo.vue?vue&type=style&index=0&id=140804a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140804a0",
  null
  
)

export default component.exports